export default "__VITE_ASSET__BzGuLX9$__"